export default "__VITE_ASSET__DzyfrwqL__"